import React from 'react';

interface SensorFusionSegmentationIconProps {
  style?: React.CSSProperties;
}

const SensorFusionSegmentationIcon: React.FC<SensorFusionSegmentationIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Sensor Fusion Segmentation</title>
      <g clipPath="url(#clip0)">
        <path d="M25.98 22.5v-15L12.99 0 0 7.5v15L12.99 30l12.99-7.5z" fill="#6A11EA" />
        <path d="M12.99 9.15a1.95 1.95 0 1 0 0-3.9 1.95 1.95 0 0 0 0 3.9z" fill="#DD45D3" />
        <path
          d="M6.237 13.05a1.95 1.95 0 1 0 0-3.9 1.95 1.95 0 0 0 0 3.9zM6.237 20.85a1.95 1.95 0 1 0 0-3.9 1.95 1.95 0 0 0 0 3.9z"
          fill="#FD9D52"
        />
        <path d="M19.746 13.05a1.95 1.95 0 1 0 0-3.9 1.95 1.95 0 0 0 0 3.9z" fill="#943CFF" />
        <path d="M12.99 16.95a1.95 1.95 0 1 0 0-3.9 1.95 1.95 0 0 0 0 3.9z" fill="#DD45D3" />
        <path d="M19.746 20.85a1.95 1.95 0 1 0 0-3.9 1.95 1.95 0 0 0 0 3.9z" fill="#943CFF" />
        <path d="M12.99 24.75a1.95 1.95 0 1 0 0-3.9 1.95 1.95 0 0 0 0 3.9z" fill="#DD45D3" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h25.98v30H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SensorFusionSegmentationIcon;
